import type { WorkspaceSubscription } from './useWorkspaces';

export interface ProductWorkspaceSubscriptionLike {
    id?: string | null;
    planId?: string | null;
    status?: string | null;
    isInTrial?: boolean | null;
    currentPeriodEnd?: string | null;
    trialEndAt?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    createdAt?: string | null;
    provider?: string | null;
    planCode?: string | null;
    planName?: string | null;
    planTier?: string | null;
    billingCycle?: string | null;
    planLabel?: string | null;
    planBadge?: string | null;
    statusLabel?: string | null;
    statusMessage?: string | null;
    actionLabel?: string | null;
    nextAction?: string | null;
}

export const normalizeProductWorkspaceSubscription = (
    subscription?: ProductWorkspaceSubscriptionLike | null,
): WorkspaceSubscription | null => {
    if (!subscription?.id || !subscription.planId || !subscription.planCode) {
        return null;
    }

    return {
        id: subscription.id,
        plan_id: subscription.planId,
        status: subscription.status || 'active',
        is_in_trial: subscription.isInTrial,
        current_period_end: subscription.currentPeriodEnd || null,
        trial_end_at: subscription.trialEndAt || null,
        cancel_at_period_end: Boolean(subscription.cancelAtPeriodEnd),
        created_at: subscription.createdAt || null,
        provider: subscription.provider || null,
        plan_code: subscription.planCode,
        plan_name: subscription.planName || subscription.planCode,
        plan_tier: subscription.planTier || subscription.planCode,
        billing_cycle: subscription.billingCycle || 'monthly',
        plan_label: subscription.planLabel || undefined,
        plan_badge: subscription.planBadge || undefined,
        status_label: subscription.statusLabel || undefined,
        status_message: subscription.statusMessage || undefined,
        action_label: subscription.actionLabel || undefined,
        next_action: subscription.nextAction || undefined,
    };
};
